var cell_default = {
  "cell": "lYhsY",
  "header": "IWVAe",
  "selected": "sfMXY",
  "editing": "_9nHsG",
  "singleSelection": "_1zoLV",
  "hideLastBlock": "Xq2LC",
  "editorWrapper": "WYY6X",
  "viewerWrapper": "CWgwJ",
  "hideFirstBlock": "yTf7c",
  "editor": "vVUcC",
  "edit": "LlOVf",
  "view": "J7U-Q",
  "editingToolbarWrapper": "TS0jy",
  "selectAll": "_7VLA9",
  "disableSelection": "dmaFD"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
